import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity Messe
 */
@Entity()
export class Messe extends Partner {
  static override _class = 'Messe';

  override get type() {
    return KooperationsPartner.MESSE;
  }
}
